import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ApiKeysTab, AutomationsTab, CampaignsTab, MessagesTab, TemplatesTab } from '@/components/communications/CommunicationTabPanels';
import { WorkflowCenterTab } from '@/components/communications/WorkflowCenter';

export function CommunicationsTabs({ data, actions, helpers }) {
  const { templates, messages, campaigns, apiKeys, dbas, automationDbaId, automationResult } = data;
  const { openTemplateEditor, deleteTemplate, openPreview, setAutomationDbaId, runAutomations, createCampaign, executeCampaign, revokeKey, openNewKeyDialog } = actions;
  const { dbaName, messageStatusClass } = helpers;
  return (
    <>
      <Tabs defaultValue="templates" data-testid="comms-tabs">
        <TabsList className="mb-4 flex h-auto justify-start gap-2 overflow-x-auto rounded-[1.25rem] border border-blue-100 bg-white p-2 shadow-sm sm:rounded-md sm:border-zinc-200">
          <TabsTrigger className="min-h-11 shrink-0 rounded-2xl px-4 font-black data-[state=active]:bg-blue-600 data-[state=active]:text-white" value="templates" data-testid="tab-templates">Templates ({templates.length})</TabsTrigger>
          <TabsTrigger className="min-h-11 shrink-0 rounded-2xl px-4 font-black data-[state=active]:bg-blue-600 data-[state=active]:text-white" value="messages" data-testid="tab-messages">Messages ({messages.length})</TabsTrigger>
          <TabsTrigger className="min-h-11 shrink-0 rounded-2xl px-4 font-black data-[state=active]:bg-blue-600 data-[state=active]:text-white" value="workflows" data-testid="tab-workflows">Workflows</TabsTrigger>
          <TabsTrigger className="min-h-11 shrink-0 rounded-2xl px-4 font-black data-[state=active]:bg-blue-600 data-[state=active]:text-white" value="automations" data-testid="tab-automations">Automations</TabsTrigger>
          <TabsTrigger className="min-h-11 shrink-0 rounded-2xl px-4 font-black data-[state=active]:bg-blue-600 data-[state=active]:text-white" value="campaigns" data-testid="tab-campaigns">Campaigns ({campaigns.length})</TabsTrigger>
          <TabsTrigger className="min-h-11 shrink-0 rounded-2xl px-4 font-black data-[state=active]:bg-blue-600 data-[state=active]:text-white" value="apikeys" data-testid="tab-apikeys">API Keys</TabsTrigger>
        </TabsList>

        <TemplatesTab data={data} actions={actions} helpers={helpers} />

        <MessagesTab data={data} actions={actions} helpers={helpers} />

      <WorkflowCenterTab />

        <AutomationsTab data={data} actions={actions} helpers={helpers} />

        <CampaignsTab data={data} actions={actions} helpers={helpers} />

        <ApiKeysTab data={data} actions={actions} helpers={helpers} />
      </Tabs>
    </>
  );
}
